import React from "react";

import { styled } from "styled-components";

import { IndeterminateCheckbox } from "shared/ui/table/IndeterminateCheckbox";

/**
 * "전체 N건 선택" 컨트롤. 표 레이아웃을 건드리지 않도록 액션 버튼(삭제/영구삭제 등)
 * 왼쪽의 액션바에 배치한다. 필터된 전 데이터(모든 페이지)를 대상으로 선택/해제한다.
 *
 * @param totalCount   전체(필터된) 건수
 * @param selectedCount 현재 선택된 건수
 * @param allSelected  전체가 선택됐는지
 * @param onToggle     전체 선택/해제 토글
 */
export function SelectAllToggle({
  totalCount,
  selectedCount,
  allSelected,
  onToggle,
}) {
  return (
    <Wrap>
      <Label>
        <IndeterminateCheckbox
          checked={allSelected}
          indeterminate={selectedCount > 0 && !allSelected}
          onChange={onToggle}
        />
        전체 {totalCount}건 선택
      </Label>
      {selectedCount > 0 && <Count>선택 {selectedCount}건</Count>}
    </Wrap>
  );
}

export default SelectAllToggle;

const Wrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

const Label = styled.label`
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  color: var(--text-black, #111);
  font-family: "Noto Sans KR";
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
`;

const Count = styled.span`
  color: var(--admin-blue-default-blue, #0079e0);
  font-family: "Noto Sans KR";
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
`;
